// extracted by mini-css-extract-plugin
export default {"root":"J0lo4","muroIcon":"yy1Lz","newIcon":"_3XUg7"};